/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Roadmap/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Roadmap({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Roadmap",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 18,
  height = 18,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Roadmap.Svg"
  data-view-path={viewPath}
 viewBox="0 0 18 18"
 style={{'--as-1-1n1nuI': alignSelf,'--mt-2-1n1nuI': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1n1nuI': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1n1nuI': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1n1nuI': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1n1nuI': opacity,'--w-10-1n1nuI': typeof width === 'number' ? `${width}px` : width,'--h-11-1n1nuI': typeof height === 'number' ? `${height}px` : height,'--f-12-1n1nuI': fill,'--a-7-1n1nuI': isAnimated ? animation : "none",'--sd-8-1n1nuI': isAnimated ? strokeDashoffset : 0,'--sd-9-1n1nuI': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<g
  data-testid="Tysiav2Roadmap.SvgGroup"
  data-view-path={viewPath}
 clipPath="url(#clip0_1869_24486)"
 className="views-block"
>
<path
  data-testid="Tysiav2Roadmap.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M2 3.5A1.5 1.5 0 013.5 2h8A1.5 1.5 0 0113 3.5v3.065A5 5 0 007.074 14H3.5A1.5 1.5 0 012 12.5v-9zm2.5 1.375a.625.625 0 100 1.25H7a.625.625 0 100-1.25H4.5zm0 2.5a.625.625 0 100 1.25H6a.625.625 0 100-1.25H4.5zM11.25 9a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zM7.5 11.25a3.75 3.75 0 116.879 2.068l1.401 1.402a.75.75 0 11-1.06 1.06l-1.402-1.401A3.75 3.75 0 017.5 11.25z"
 style={{'--f-12-1n1nuI': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}